import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'li3-input-form-item',
  templateUrl: './input-form-item.component.html',
  styleUrls: ['./input-form-item.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFormItemComponent),
      multi: true
    }
  ]
})
export class InputFormItemComponent implements OnInit, ControlValueAccessor {
  @Input() frmGroup: FormGroup;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() type: string;
  @Input() name: string;
  @Input() value: string;
  @Input() id: string;
  @Input() testId: string;
  @Input() maxLength: string;
  @Input() isInvalid: boolean;
  @Input() disabled: boolean;
  @Input() errorMessage: string;
  @Input() errorMessageTestId: string;
  @Output() focused = new EventEmitter();
  @Output() blurred = new EventEmitter();
  @Output() change = new EventEmitter();

  propagateChange = function (_: any) {
  };

  constructor() {
  }

  ngOnInit() {
  }

  writeValue(value: any) {
    this.value = value;
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {
  }

  onChange(event) {
    this.propagateChange(event.target.value);
    this.change.emit(event.target.value);
  }

  onFocus() {
    this.focused.emit();
  }

  onBlur() {
    this.blurred.emit();
  }
}
